import { get } from "lodash/fp";

export const isLoadingSelector = state => (
  get('stationSearch.isLoading')(state)
);

export const getStationsSelector = state => (
  get('stationSearch.stations')(state)
);